import { render, staticRenderFns } from "./tableScatter.vue?vue&type=template&id=84f3114c&scoped=true&"
import script from "./tableScatter.vue?vue&type=script&lang=ts&"
export * from "./tableScatter.vue?vue&type=script&lang=ts&"
import style0 from "./tableScatter.vue?vue&type=style&index=0&id=84f3114c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84f3114c",
  null
  
)

export default component.exports